<template>
  <v-snackbar v-model="show" value="true" right top multi-line :color="type" :timeout="time" >
    <div v-html="text"></div>
    <v-btn dark flat @click="show = false">
      {{ $t('OK') }}
    </v-btn>
  </v-snackbar>
</template>

<script>
const DEFAULT_ALERT_TIMEOUT = 5000;
const ERROR_ALERT_TIMEOUT  = 20000;

export default {
  data() {
    return {
      type: '',
      text: '',
      time: DEFAULT_ALERT_TIMEOUT,
      show: false,
    }
  },
  methods: {
    popup(text, type, time) {
      this.type = type || 'info';
      this.time = time !== undefined ? time : (type === 'error' ? ERROR_ALERT_TIMEOUT : DEFAULT_ALERT_TIMEOUT);
      this.text = text;
      this.show = true;
    }
  }
}
</script>